export const MENTION_TOKEN_RE = /@\[[^\]]+\]\(mention:(\d+)\)/g;

export type MentionableOrgUser = {
  id: number;
  username: string;
  email: string;
};

export function buildMentionToken(
  user: Pick<MentionableOrgUser, "id" | "username">,
) {
  return `@[${user.username}](mention:${user.id})`;
}

export function stripMentionTokens(body: string): string {
  return body.replace(MENTION_TOKEN_RE, (token) => {
    const end = token.indexOf("]");
    return `@${token.slice(2, end)}`;
  });
}

export type NoteBodySegment =
  | { type: "text"; value: string }
  | { type: "mention"; username: string; userId: number };

export function parseNoteBodySegments(body: string): NoteBodySegment[] {
  const segments: NoteBodySegment[] = [];
  let lastIndex = 0;
  const regex = new RegExp(MENTION_TOKEN_RE.source, "g");
  let match: RegExpExecArray | null;

  while ((match = regex.exec(body)) !== null) {
    if (match.index > lastIndex) {
      segments.push({
        type: "text",
        value: body.slice(lastIndex, match.index),
      });
    }
    const token = match[0];
    const end = token.indexOf("]");
    segments.push({
      type: "mention",
      username: token.slice(2, end),
      userId: Number(match[1]),
    });
    lastIndex = match.index + token.length;
  }

  if (lastIndex < body.length) {
    segments.push({ type: "text", value: body.slice(lastIndex) });
  }

  return segments;
}

export function getActiveMentionQuery(
  value: string,
  cursorPosition: number,
): { query: string; start: number } | null {
  const beforeCursor = value.slice(0, cursorPosition);
  const atIndex = beforeCursor.lastIndexOf("@");
  if (atIndex === -1) return null;

  const afterAt = beforeCursor.slice(atIndex + 1);
  if (afterAt.includes("\n") || afterAt.includes("(")) return null;

  return { query: afterAt, start: atIndex };
}
